import { create } from 'zustand';
import type { SelectedCategory } from '@/types';

interface ResponsesPanelState {
  isOpen: boolean;
  questionId: string | null;
  /**
   * Active category filter. Multi-select so researchers can look at
   * "Positive OR Negative" responses in one view, matching the pre-redesign
   * inline table. An empty array means "no filter — show everything".
   */
  selectedCategories: SelectedCategory[];
  open: (questionId: string, category?: SelectedCategory) => void;
  close: () => void;
  setSelectedCategories: (categories: SelectedCategory[]) => void;
  /** Clear just the category filter without closing the panel. */
  clearCategories: () => void;
}

const useResponsesPanelStore = create<ResponsesPanelState>((set) => ({
  isOpen: false,
  questionId: null,
  selectedCategories: [],
  open: (questionId, category) =>
    set({
      isOpen: true,
      questionId,
      selectedCategories: category ? [category] : [],
    }),
  close: () => set({ isOpen: false, questionId: null, selectedCategories: [] }),
  setSelectedCategories: (categories) => set({ selectedCategories: categories }),
  clearCategories: () => set({ selectedCategories: [] }),
}));

export default useResponsesPanelStore;
